/* eslint-disable no-shadow */
export enum FinancialFormTypeEnum {
  LOAN = "LoanFinancialForm",
  FULL_PAYMENT = "FullPaymentFinancialForm",
  CREDIT_LINE = "CreditLineFinancialForm",
}

export enum FinancialFormStatusEnum {
  PENDING = "pending",
  IN_VALIDATION = "inValidation",
  APPROVED = "approved",
  CONTACTED = "contacted",
  REJECTED = "rejected",
  REJECTED_KYC = "rejectedKyc",
  UPLOAD_RECEIPT = "uploadReceipt",
  REVIEWED = "reviewed",
  SCHEDULED = "scheduled",
  COMPLETED = "completed",
  EXPIRED = "expired",
  CANCELED = "canceled",
}

export const REJECTED_STATUSES = [
  FinancialFormStatusEnum.REJECTED,
  FinancialFormStatusEnum.REJECTED_KYC,
];

export enum VehiclePurposeEnum {
  PERSONAL = "personal",
  COMERCIAL = "comercial",
}

export enum RejectedReasonEnum {
  LessThanThreeMonthsEmployed = "LessThanThreeMonthsEmployed",
  DeliveryPersonUsingOthersAccount = "DeliveryPersonUsingOthersAccount",
  InformationInconsistencies = "InformationInconsistencies",
  PaymentCapacity = "PaymentCapacity",
  Truora = "Truora",
  Fraud = "Fraud",
  Zoning = "Zoning",
  Seon = "Seon",
  PreviousRecovery = "PreviousRecovery",
  Unemployment = "Unemployment",
  Address = "Address",
  DocumentsFromOtherPeople = "DocumentsFromOtherPeople",
  Age = "Age",
  Occupation = "Occupation",
  OzonersTypeD = "OzonersTypeD",
  TemporaryResidentForeigners = "TemporaryResidentForeigners",
  ForgedDocuments = "ForgedDocuments",
  Trully = "Trully",
  LowIncome = "LowIncome",
  LoanOfferNoValidTier = "LoanOfferNoValidTier",
  LoanOfferNoViableOffers = "LoanOfferNoViableOffers",
  IdentityValidation = "IdentityValidation",
}

export enum FinancialFormDocsEnum {
  INE_FRONT = "ine_front",
  INE_BACK = "ine_back",
  SELFIE = "selfie",
  PROOF_OF_ADDRESS = "proof_of_address",
  BANK_CERTIFICATE_1 = "bank_certificate_1",
  BANK_CERTIFICATE_2 = "bank_certificate_2",
  BANK_CERTIFICATE_3 = "bank_certificate_3",
  RESERVATION_RECEIPT = "layawayReceipt",
  TAX_SITUATION = "tax_situation",
}
